// All video types
const VideoTypes = {
  SERIES: 'Series',
  FEATURED_FILM: 'Full Feature Film',
  SHORT_FILM: 'Short Film',
};

export default VideoTypes;
